/** English occupies more width per word, so it sits a little smaller than CJK. */
export const STUDIO_EN_TYPE_SCALE = 0.92;

export const studioTypeScaleFor = (locale?: string): number => (locale === 'en' ? STUDIO_EN_TYPE_SCALE : 1);

export const studioTypeSize = (px: number, locale?: string): number => {
  const scale = studioTypeScaleFor(locale);
  return scale === 1 ? px : Math.round(px * scale * 2) / 2;
};
